module.exports = __webpack_public_path__ + "static/media/search-minus.bef023d7.svg";